const cookieBar = document.querySelector(".cookie-bar");
const cookieBarTogglers = document.querySelectorAll(".js--cookie-modal-toggle");
const hasCookieBarTogglers = cookieBarTogglers.length > 0;

let cookieBarChangePreferences;
if (cookieBar) {
    cookieBarChangePreferences = cookieBar.querySelector(".js-change-preferences");
}

if (cookieBar && hasCookieBarTogglers && cookieBarChangePreferences) {
    [].forEach.call(cookieBarTogglers, toggler => {
        toggler.addEventListener("click", e => {
            e.preventDefault();
            cookieBar.classList.add("open");
            cookieBar.classList.add("active");
            cookieBarChangePreferences.classList.remove("active");
            focusOnFirstCookieBarEl()
        });
    });
}

if (cookieBar && cookieBarChangePreferences) {
    cookieBarChangePreferences.addEventListener("click", () => {
        cookieBar.classList.add("active");
        cookieBarChangePreferences.classList.remove("active");
        focusOnFirstCookieBarEl()
    })
}

/** Focus on the first focusable element in the cookie bar **/
function focusOnFirstCookieBarEl () {
    const firstFocusableEl = cookieBar.querySelector('button, [href], input');
    firstFocusableEl.focus();
}